'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');
require('jquery-validation');
var processInclude = require('base/util');
require('cssuseragent');

$(document).ready(function () {
    // Only above-the-fold components
    processInclude(require('./components/menu'));
    processInclude(require('./components/search'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/stickyHeader.js'));
    processInclude(require('./components/deliveryMethodPopin.js'));
    processInclude(require('./components/bottomSheet.js'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/oneTimeModal.js'));
});

$(window).on('load', function() {
    processInclude(require('./components/cookie'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/formFields'));
    processInclude(require('./components/controlledPhoneInput.js'));
});

/**
 * Carga los componentes de los modales solo cuando se necesitan
 */
function loadModalComponents() {
    if (!window.modalsLoaded) {
        processInclude(require('./components/deliveryModal/deliveryModal.js'));
        processInclude(require('./components/notificationMessage.js'));
        window.modalsLoaded = true;
    }
}

/**
 * Event handler that runs once on the user's first interaction with the page.
 * @returns {void}
 */
function handleFirstInteraction() {
    loadModalComponents();
    $(window).off('mousemove touchstart keydown click', handleFirstInteraction);
}

$(window).on('mousemove touchstart keydown click', handleFirstInteraction);

require('base/thirdParty/bootstrap');
require('base/components/spinner');
require('jquery-hoverintent');